import React from "react";
import { Check } from "lucide-react";

const LABELS = {
  profile: "Your Profile",
  capabilities: "Your Capabilities",
  routes: "Income Routes",
  direction: "Your Direction",
  blueprint: "Your Blueprint",
  validate: "Your 2nd Income Validator",
};

export const STEP_IDS = ["profile", "capabilities", "routes", "direction", "blueprint", "validate"];

export const Stepper = ({ step, progress, onStep }) => {
  const reached = (id) => {
    const order = STEP_IDS.indexOf(id);
    const unlocked = {
      profile: true,
      capabilities: progress.profile_complete,
      routes: progress.capabilities_confirmed > 0,
      direction: progress.hypotheses > 0,
      blueprint: progress.has_primary,
      validate: !!progress.blueprint_status,
    };
    return { unlocked: unlocked[id], done: STEP_IDS.indexOf(progress.step) > order };
  };

  return (
    <nav className="-mx-4 px-4 overflow-x-auto sm:mx-0 sm:px-0" data-testid="accelerator-stepper">
      <ol className="flex gap-2 min-w-max sm:min-w-0 sm:flex-wrap">
        {STEP_IDS.map((id, i) => {
          const { unlocked, done } = reached(id);
          const active = step === id;
          return (
            <li key={id}>
              <button
                disabled={!unlocked}
                onClick={() => onStep(id)}
                data-testid={`accelerator-step-${id}`}
                className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-2 text-xs transition-colors ${
                  active
                    ? "border-sky-200 bg-sky-50 text-sky-700"
                    : unlocked
                    ? "border-slate-300 bg-white text-slate-700 hover:border-slate-300"
                    : "border-slate-200 bg-white text-slate-400"
                }`}
              >
                <span className={`w-5 h-5 rounded-full grid place-items-center text-[10px] font-bold ${done ? "bg-emerald-50 text-emerald-700" : active ? "bg-sky-50 text-sky-700" : "bg-slate-100 text-slate-500"}`}>
                  {done ? <Check className="w-3 h-3" /> : i + 1}
                </span>
                {LABELS[id]}
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Stepper;
